import { useParams } from '@tanstack/react-router';
import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import SurfaceCanvas from '~/components2/Map/canvas/Surface';
import { mapState } from '~/components2/Map/Map';
import CustomDataLayers from './CustomDataLayers';
import GeoreferencedMapLayers from './GeoreferencedMapLayers';
import ProjectDataLayers from './ProjectDataLayers';
import store from './projectDetailsMapStore';

export default function Surface() {
  const { current: map } = useMap();
  const { objectsAsArray } = useSnapshot(store) as typeof store;
  const container = useRef<HTMLDivElement>(null);
  const { projectId } = useParams({ strict: false }) as { projectId?: string };

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (container.current && map) {
      const surface = new SurfaceCanvas({
        id: `project-detail-map-surface-${nanoid()}`,
        container: container.current,
        map: map.getMap(),
        store,
      });

      const unsubscribe = subscribe(mapState, () => {
        surface.refreshScreenCoords();
      });

      return () => {
        unsubscribe();
        surface.destroy();
      };
    }
  }, []);

  const isVisible = objectsAsArray.length > 0;

  if (!map) {
    return null;
  }

  return (
    <>
      {projectId && <ProjectDataLayers projectId={projectId} />}
      {projectId && <CustomDataLayers key={projectId} projectId={projectId} />}
      {projectId && <GeoreferencedMapLayers key={projectId} projectId={projectId} />}
      <div
        id="edit-geometry-surface-container"
        style={{ cursor: '-moz-grab' }}
        className={`absolute left-0 top-0 ${isVisible ? 'visible' : 'hidden'}`}
        ref={container}
      ></div>
    </>
  );
}
